/**
 * 简单计数锁
 */
class SimpleLocker {
    constructor() {
        this._lockerCount = 0;
    }

    lock() {
        this._lockerCount++;
    }

    unlock() {
        this._lockerCount--;
        if (this._lockerCount < 0)
            this._lockerCount = 0;
    }

    reset() {
        this._lockerCount = 0;
    }

    isLock() {
        return this._lockerCount > 0;
    }
}

module.exports = SimpleLocker